import { Textarea } from "@/components/ui/textarea";
import { Sparkles, Layers } from "lucide-react";
import { Card, SecTitle, Chip, profCls } from "./parts";

export function SkillsTab({ p, editing, set }) {
  return (
    <div className="space-y-4">
      <SecTitle icon={Sparkles} conf={p.confidence?.skills}>Skill matrix</SecTitle>
      {editing && (
        <Card className="space-y-2"><div className="text-xs text-muted-foreground">Skills (comma separated)</div>
          <Textarea value={(p.skills || []).map((s) => (typeof s === "string" ? s : s.name)).join(", ")} onChange={(e) => set("skills", e.target.value.split(",").map((x) => x.trim()).filter(Boolean))} rows={3} data-testid="edit-skills" />
          <div className="text-xs text-muted-foreground pt-1">Tools (comma separated)</div>
          <Textarea value={(p.tools || []).map((s) => (typeof s === "string" ? s : s.name)).join(", ")} onChange={(e) => set("tools", e.target.value.split(",").map((x) => x.trim()).filter(Boolean))} rows={2} />
        </Card>
      )}
      {(p.skill_categories || []).length > 0 ? (p.skill_categories || []).map((cat, ci) => (
        <Card key={ci} data-testid={`skillcat-${ci}`}>
          <div className="font-mono text-[11px] uppercase tracking-[0.15em] text-primary/80 mb-3">{cat.category}</div>
          <div className="space-y-2">
            {(cat.skills || []).map((s, si) => {
              const name = typeof s === "string" ? s : s.name;
              const prof = typeof s === "object" ? s.proficiency : null;
              return (
                <div key={si} className="flex items-center gap-3 text-sm">
                  <span className="font-medium min-w-[140px]">{name}</span>
                  {prof && <span className={`text-[10px] px-2 py-0.5 rounded-full border ${profCls(prof)}`}>{prof}</span>}
                  {typeof s === "object" && s.recency && <span className="text-[11px] text-muted-foreground">{s.recency}</span>}
                  {typeof s === "object" && s.evidence && <span className="text-[11px] text-muted-foreground italic truncate flex-1">“{s.evidence}”</span>}
                </div>
              );
            })}
          </div>
        </Card>
      )) : (
        <Card><div className="flex flex-wrap gap-2">{(p.skills || []).map((s, i) => <Chip key={i}>{typeof s === "string" ? s : s.name}</Chip>)}</div></Card>
      )}
      {(p.tools || []).length > 0 && <Card><SecTitle icon={Layers}>Tools & platforms</SecTitle><div className="flex flex-wrap gap-2">{p.tools.map((t, i) => <Chip key={i}>{typeof t === "string" ? t : t.name}</Chip>)}</div></Card>}
    </div>
  );
}
